import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import Echo from 'laravel-echo'
import VueEcho from 'vue-echo/vue-echo'

// Import NameSpaceHelper ModuleNames
import {
  Settings,
  BrandConfigurationCI,
  SettingsModuleName,
  ManufacturersSettingsModuleName,
  ContactFunctionsSettingsModuleName,
  TermsOfDeliverySettingsModuleName,
  TermsOfPaymentSettingsModuleName,
  ContactPersonSettingsModuleName,
  CustomerModuleName,
  CustomerBranchOfficeModuleName,
  CustomerBranchOfficeContactModuleName,
  CustomerBranchOfficeBankAccountsModuleName,
  InquiryModuleName,
  InquiryPositionModuleName,
  InquirySupplierRequestsModuleName,
  UserSettingsModuleName,
  ManufacturerBranchOfficeSettingsModuleName,
  DocumentsModuleName,
  SupplierOffersModuleName,
  SupplierOfferDeclinesModuleName,
  SupplierOfferPositionDeclinesModuleName,
  SupplierOfferPositionModuleName,
  OfferModuleName,
  OfferPositionModuleName,
  ProductSettingsModuleName,
  VatSettingsModuleName,
  DashboardModuleName,
  PurchaseOrderModuleName,
  PurchaseOrderPositionModuleName,
  ProcurementModuleName,
  ProcurementPositionModuleName,
  HistoryModuleName,
  SupplierOrderModuleName,
  SupplierOrderProformaModuleName,
  SupplierOrderPositionModuleName,
  FollowUpModuleName,
  InvoiceModuleName,
  InvoicePositionModuleName,
  SupplierOrderPositionReceivedModuleName,
  PickingModuleName,
  PickingPositionModuleName,
  BrandConfigurationModuleName,
  BrandConfigurationCIModuleName,
  BrandConfigurationBranchOfficesModuleName,
  BrandConfigurationMailSettingsModuleName,
  BrandConfigurationShopifySettingsModuleName,
  GoggleAdWordsModuleName,
  CashFlowModuleName,
  ProductListingsModuleName

} from './namespace-helper'

// Import Store modules
import settingsModule from './Settings/settings'
import settingsManufacturersModule from './Settings/manufacturers'
import settingsManufacturerBranchOfficesModule from './Settings/manufacturerBranchOffices'
import settingsContactFunctionsModule from './Settings/contactFunctions'
import settingsTermsOfDeliveriesModule from './Settings/termsOfDeliveries'
import settingsTermsOfPaymentsModule from './Settings/termsOfPayments'
import settingsContactPersonModule from './Settings/contactPersons'
import customersModule from './Customer/customers'
import userSettingsModuleName from './Settings/users'
import customerBranchOfficesModule from './Customer/customerBranchOffices'
import customerBranchOfficesContactModule from './Customer/customerBranchOfficesContact'
import customerBranchOfficesBankAccountModule from './Customer/customerBranchOfficesBankAccounts'
import inquiryModule from './Inquiry/inquiries'
import inquiryPositionModule from './InquiryPositions/inquiriesPositions'
import inquirySupplierRequestModule from './InquirySupplierRequests/inquirySupplierRequests'
import documentsModule from './Document/documents'
import supplierOfferModule from './SupplierOffer/supplierOffers'
import supplierOfferDeclineModule from './SupplierOfferDeclines/supplierOffersDeclines'
import supplierOfferPositionDeclineModule from './SupplierOfferPositionDeclines/supplierOffersPositionDeclines'
import supplierOfferPositionModule from './SupplierOfferPosition/supplierOfferPositions'
import offerModule from './Offer/offers'
import offerPositionModule from './OfferPosition/offersPositions'
import productsSettingsModule from './Settings/products'
import vatsSettingsModule from './Settings/vats'
import dashboardModule from './Dashboard/dashboard'
import purchaseOrderModule from './PurchaseOrder/purchaseOrders'
import purchaseOrderPositionModule from './PurchaseOrderPositions/purchaseOrderPositions'
import procurementModule from './Procurement/procurements'
import procurementPositionModule from './ProcurementPositions/procurementPositions'
import historyModule from './History/histories'
import supplierOrderModule from './SupplierOrder/supplierOrders'
import supplierOrderProformaModule from './SupplierOrderProforma/supplierOrderProformas'
import supplierOrderPositionModule from './SupplierOrderPosition/supplierOrderPositions'
import followUpModule from './FollowUp/followUp'
import invoiceModule from './Invoice/invoices'
import invoicePositionModule from './InvoicePosition/invoicePositions'
import supplierOrderPositionReceived from './SupplierOrderPositionsReceived/supplierOrderPositionsReceived'
import pickingModule from './Picking/pickings'
import pickingPositionModule from './PickingPosition/pickingPositions'
import brandConfigurationModule from './BrandConfiguration/brandConfigurations'
import brandConfigurationCIModule from './BrandConfiguration/brandConfigurationsCI'
import brandConfigurationBranchOfficeModule from './BrandConfiguration/brandConfigurationsBranchOffices'
import brandConfigurationMailSettingsModule from './BrandConfiguration/brandConfigurationsMailSettings'
import brandConfigurationShopifySettingsModule from './BrandConfiguration/brandConfigurationsShopifySettings'
import googleAdWordsModule from './GoogleAdword/googleAdWords'
import cashFlowModule from './CashFlow/cashFlow'
import productListingsModule from './ProductListings/productListings'

Vue.use(Vuex)

export const store = new Vuex.Store({
  modules: {
    [SettingsModuleName]: settingsModule,
    [ManufacturersSettingsModuleName]: settingsManufacturersModule,
    [ManufacturerBranchOfficeSettingsModuleName]: settingsManufacturerBranchOfficesModule,
    [ContactFunctionsSettingsModuleName]: settingsContactFunctionsModule,
    [TermsOfDeliverySettingsModuleName]: settingsTermsOfDeliveriesModule,
    [TermsOfPaymentSettingsModuleName]: settingsTermsOfPaymentsModule,
    [ContactPersonSettingsModuleName]: settingsContactPersonModule,
    [CustomerModuleName]: customersModule,
    [CustomerBranchOfficeModuleName]: customerBranchOfficesModule,
    [CustomerBranchOfficeContactModuleName]: customerBranchOfficesContactModule,
    [CustomerBranchOfficeBankAccountsModuleName]: customerBranchOfficesBankAccountModule,
    [InquiryModuleName]: inquiryModule,
    [InquiryPositionModuleName]: inquiryPositionModule,
    [InquirySupplierRequestsModuleName]: inquirySupplierRequestModule,
    [UserSettingsModuleName]: userSettingsModuleName,
    [DocumentsModuleName]: documentsModule,
    [SupplierOffersModuleName]: supplierOfferModule,
    [SupplierOfferDeclinesModuleName]: supplierOfferDeclineModule,
    [SupplierOfferPositionDeclinesModuleName]: supplierOfferPositionDeclineModule,
    [SupplierOfferPositionModuleName]: supplierOfferPositionModule,
    [OfferModuleName]: offerModule,
    [OfferPositionModuleName]: offerPositionModule,
    [ProductSettingsModuleName]: productsSettingsModule,
    [VatSettingsModuleName]: vatsSettingsModule,
    [DashboardModuleName]: dashboardModule,
    [PurchaseOrderModuleName]: purchaseOrderModule,
    [PurchaseOrderPositionModuleName]: purchaseOrderPositionModule,
    [ProcurementModuleName]: procurementModule,
    [ProcurementPositionModuleName]: procurementPositionModule,
    [HistoryModuleName]: historyModule,
    [SupplierOrderModuleName]: supplierOrderModule,
    [SupplierOrderProformaModuleName]: supplierOrderProformaModule,
    [SupplierOrderPositionModuleName]: supplierOrderPositionModule,
    [FollowUpModuleName]: followUpModule,
    [InvoiceModuleName]: invoiceModule,
    [InvoicePositionModuleName]: invoicePositionModule,
    [SupplierOrderPositionReceivedModuleName]: supplierOrderPositionReceived,
    [PickingModuleName]: pickingModule,
    [PickingPositionModuleName]: pickingPositionModule,
    [BrandConfigurationModuleName]: brandConfigurationModule,
    [BrandConfigurationCIModuleName]: brandConfigurationCIModule,
    [BrandConfigurationBranchOfficesModuleName]: brandConfigurationBranchOfficeModule,
    [BrandConfigurationMailSettingsModuleName]: brandConfigurationMailSettingsModule,
    [BrandConfigurationShopifySettingsModuleName]: brandConfigurationShopifySettingsModule,
    [GoggleAdWordsModuleName]: googleAdWordsModule,
    [CashFlowModuleName]: cashFlowModule,
    [ProductListingsModuleName]: productListingsModule
  },
  state: {
    countries:
    ['AF - Afghanistan',
      'AX - Åland Islands',
      'AL - Albania',
      'DZ - Algeria',
      'AS - American Samoa',
      'AD - Andorra',
      'AO - Angola',
      'AI - Anguilla',
      'AQ - Antarctica',
      'AG - Antigua and Barbuda',
      'AR - Argentina',
      'AM - Armenia',
      'AW - Aruba',
      'AU - Australia',
      'AT - Austria',
      'AZ - Azerbaijan',
      'BS - Bahamas',
      'BH - Bahrain',
      'BD - Bangladesh',
      'BB - Barbados',
      'BY - Belarus',
      'BE - Belgium',
      'BZ - Belize',
      'BJ - Benin',
      'BM - Bermuda',
      'BT - Bhutan',
      'BO - Bolivia',
      'BA - Bosnia and Herzegovina',
      'BW - Botswana',
      'BV - Bouvet Island',
      'BR - Brazil',
      'IO - British Indian Ocean Territory',
      'BN - Brunei Darussalam',
      'BG - Bulgaria',
      'BF - Burkina Faso',
      'BI - Burundi',
      'KH - Cambodia',
      'CM - Cameroon',
      'CA - Canada',
      'CV - Cape Verde',
      'KY - Cayman Islands',
      'CF - Central African Republic',
      'TD - Chad',
      'CL - Chile',
      'CN - China',
      'CX - Christmas Island',
      'CC - Cocos (Keeling) Islands',
      'CO - Colombia',
      'KM - Comoros',
      'CG - Congo',
      'CD - Congo, The Democratic Republic of The',
      'CK - Cook Islands',
      'CR - Costa Rica',
      "CI - Cote D'ivoire",
      'HR - Croatia',
      'CU - Cuba',
      'CY - Cyprus',
      'CZ - Czechia',
      'DK - Denmark',
      'DJ - Djibouti',
      'DM - Dominica',
      'DO - Dominican Republic',
      'EC - Ecuador',
      'EG - Egypt',
      'SV - El Salvador',
      'GQ - Equatorial Guinea',
      'ER - Eritrea',
      'EE - Estonia',
      'ET - Ethiopia',
      'FK - Falkland Islands (Malvinas)',
      'FO - Faroe Islands',
      'FJ - Fiji',
      'FI - Finland',
      'FR - France',
      'GF - French Guiana',
      'PF - French Polynesia',
      'TF - French Southern Territories',
      'GA - Gabon',
      'GM - Gambia',
      'GE - Georgia',
      'DE - Germany',
      'GH - Ghana',
      'GI - Gibraltar',
      'GR - Greece',
      'GL - Greenland',
      'GD - Grenada',
      'GP - Guadeloupe',
      'GU - Guam',
      'GT - Guatemala',
      'GG - Guernsey',
      'GN - Guinea',
      'GW - Guinea-bissau',
      'GY - Guyana',
      'HT - Haiti',
      'HM - Heard Island and Mcdonald Islands',
      'VA - Holy See (Vatican City State)',
      'HN - Honduras',
      'HK - Hong Kong',
      'HU - Hungary',
      'IS - Iceland',
      'IN - India',
      'ID - Indonesia',
      'IR - Iran, Islamic Republic of',
      'IQ - Iraq',
      'IE - Ireland',
      'IM - Isle of Man',
      'IL - Israel',
      'IT - Italy',
      'JM - Jamaica',
      'JP - Japan',
      'JE - Jersey',
      'JO - Jordan',
      'KZ - Kazakhstan',
      'KE - Kenya',
      'KI - Kiribati',
      "KP - Korea, Democratic People's Republic of",
      'KR - Korea, Republic of',
      'KW - Kuwait',
      'KG - Kyrgyzstan',
      "LA - Lao People's Democratic Republic",
      'LV - Latvia',
      'LB - Lebanon',
      'LS - Lesotho',
      'LR - Liberia',
      'LY - Libyan Arab Jamahiriya',
      'LI - Liechtenstein',
      'LT - Lithuania',
      'LU - Luxembourg',
      'MO - Macao',
      'MK - Macedonia, The Former Yugoslav Republic of',
      'MG - Madagascar',
      'MW - Malawi',
      'MY - Malaysia',
      'MV - Maldives',
      'ML - Mali',
      'MT - Malta',
      'MH - Marshall Islands',
      'MQ - Martinique',
      'MR - Mauritania',
      'MU - Mauritius',
      'YT - Mayotte',
      'MX - Mexico',
      'FM - Micronesia, Federated States of',
      'MD - Moldova, Republic of',
      'MC - Monaco',
      'MN - Mongolia',
      'ME - Montenegro',
      'MS - Montserrat',
      'MA - Morocco',
      'MZ - Mozambique',
      'MM - Myanmar',
      'NA - Namibia',
      'NR - Nauru',
      'NP - Nepal',
      'NL - Netherlands',
      'AN - Netherlands Antilles',
      'NC - New Caledonia',
      'NZ - New Zealand',
      'NI - Nicaragua',
      'NE - Niger',
      'NG - Nigeria',
      'NU - Niue',
      'NF - Norfolk Island',
      'MP - Northern Mariana Islands',
      'NO - Norway',
      'OM - Oman',
      'PK - Pakistan',
      'PW - Palau',
      'PS - Palestinian Territory, Occupied',
      'PA - Panama',
      'PG - Papua New Guinea',
      'PY - Paraguay',
      'PE - Peru',
      'PH - Philippines',
      'PN - Pitcairn',
      'PL - Poland',
      'PT - Portugal',
      'PR - Puerto Rico',
      'QA - Qatar',
      'RE - Reunion',
      'RO - Romania',
      'RU - Russian Federation',
      'RW - Rwanda',
      'SH - Saint Helena',
      'KN - Saint Kitts and Nevis',
      'LC - Saint Lucia',
      'PM - Saint Pierre and Miquelon',
      'VC - Saint Vincent and The Grenadines',
      'WS - Samoa',
      'SM - San Marino',
      'ST - Sao Tome and Principe',
      'SA - Saudi Arabia',
      'SN - Senegal',
      'RS - Serbia',
      'SC - Seychelles',
      'SL - Sierra Leone',
      'SG - Singapore',
      'SK - Slovakia',
      'SI - Slovenia',
      'SB - Solomon Islands',
      'SO - Somalia',
      'ZA - South Africa',
      'GS - South Georgia and The South Sandwich Islands',
      'ES - Spain',
      'LK - Sri Lanka',
      'SD - Sudan',
      'SR - Suriname',
      'SJ - Svalbard and Jan Mayen',
      'SZ - Swaziland',
      'SE - Sweden',
      'CH - Switzerland',
      'SY - Syrian Arab Republic',
      'TW - Taiwan, Province of China',
      'TJ - Tajikistan',
      'TZ - Tanzania, United Republic of',
      'TH - Thailand',
      'TL - Timor-leste',
      'TG - Togo',
      'TK - Tokelau',
      'TO - Tonga',
      'TT - Trinidad and Tobago',
      'TN - Tunisia',
      'TR - Turkey',
      'TM - Turkmenistan',
      'TC - Turks and Caicos Islands',
      'TV - Tuvalu',
      'UG - Uganda',
      'UA - Ukraine',
      'AE - United Arab Emirates',
      'GB - United Kingdom',
      'US - United States',
      'UM - United States Minor Outlying Islands',
      'UY - Uruguay',
      'UZ - Uzbekistan',
      'VU - Vanuatu',
      'VE - Venezuela',
      'VN - Viet Nam',
      'VG - Virgin Islands, British',
      'VI - Virgin Islands, U.S.',
      'WF - Wallis and Futuna',
      'EH - Western Sahara',
      'YE - Yemen',
      'ZM - Zambia',
      'ZW - Zimbabwe'],
    user: null,
    loading: false,
    ciLoading: true,
    logOutLoading: false,
    error: null,
    success: {
      text: null,
      show: false
    },
    bottomSheetState: false
  },
  mutations: {
    setUser (state, payload) {
      state.user = payload
    },
    setLoading (state, payload) {
      state.loading = payload
    },
    setCILoading (state, payload) {
      state.ciLoading = payload
    },
    setLogoutLoading (state, payload) {
      state.logOutLoading = payload
    },
    setError (state, payload) {
      state.error = payload
    },
    setSuccess (state, payload) {
      state.success = payload
    },
    clearError (state) {
      state.error = null
    },
    setbottomSheetState (state) {
      state.bottomSheetState = !state.bottomSheetState
    }
  },
  actions: {
    signUserIn ({ commit }, payload) {
      commit('setLoading', true)
      commit('clearError')

      getToken({ commit }, payload)
    },
    autoSignIn ({ commit }, payload) {
      commit('setUser', { id: payload.uid, registeredMeetups: [] })
    },
    logout ({ commit, state, getters }) {
      commit('setLogoutLoading', true)
      var url = API_URL + '/api/v1/logout'

      return axios.get(url, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + getters.getBearerToken
        }
      }
      ).then(function (r) {
        localStorage.removeItem('accessToken' + getters.user.email)
        commit('setUser', null)
        localStorage.removeItem('user')
        location.href = '/'
        // commit('setLogoutLoading', false)
      }, function (err) {
        console.log(JSON.stringify(err))
        localStorage.removeItem('accessToken' + getters.user.email)
        commit('setUser', null)
        localStorage.removeItem('user')
        location.href = '/'
        // commit('setLogoutLoading', false)
      }).catch(e => console.error('#### ' + e))
    },
    clearError ({ commit }) {
      commit('clearError')
    },
    openCloseBottomSheet ({ commit }) {
      commit('setbottomSheetState')
    },
    getCI (context) {
      var url = API_URL + '/ci'

      store.commit(Settings.mutations.setLoading, true)

      return new Promise((resolve, reject) => {
        return axios.get(url, {
          headers: {
            'Content-Type': 'application/json'
          }
        }
        ).then(function (r) {
          store.commit(BrandConfigurationCI.mutations.setDefaultCI, r.data.data[0])
          store.commit(Settings.mutations.setLoading, false)
          store.commit('setCILoading', false)
          resolve(r)
        }, function (err) {
          console.log(JSON.stringify(err))
          reject(err)
          store.commit(Settings.mutations.setLoading, false)
          store.commit('setCILoading', false)
        }).catch(e => console.error('#### ' + e))
      })
    }

  },
  getters: {
    countries (state) {
      return state.countries
    },
    user (state) {
      let user = localStorage.getItem('user')
      console.log('User from store: ' + user)
      if (user !== null) {
        try {
          user = JSON.parse(user)
        } catch (err) {
          localStorage.setItem('user', null)
        }
        const token = localStorage.getItem('accessToken' + user.email)
        if (token != null) {
          console.log('accessToken: ' + token)
          return user
        }
      }
      return state.user
    },
    loading (state) {
      return state.loading
    },
    ciLoading (state) {
      return state.ciLoading
    },
    logoutLoading (state) {
      return state.logOutLoading
    },
    error (state) {
      return state.error
    },
    success (state) {
      return state.success
    },
    getBearerToken (state) {
      if (store.getters.user !== null) {
        return localStorage.getItem('accessToken' + store.getters.user.email)
      }
      return null
    },
    getbottomSheetState (state) {
      return state.bottomSheetState
    }
  }
})

export const CLIENT_ID = '2'
export const CLIENT_SECRET = 'nufkAzl0P4kHDryl4UnpiInR72ynpFHnCVsu8aF9'

// todo check
var API_LOCATION = ''
var MOD_URI = ''
var WEBSOCKET_LOCATION = ''
if ((location.hostname !== 'localhost' && location.hostname !== '127.0.0.1')) {
  // API_LOCATION = location.protocol + '//' + location.hostname
  MOD_URI = location.hostname.replace('app.reba-group.com', 'nervous-engelbart.92-205-164-206.plesk.page')
  // MOD_URI = location.hostname.replace('work.', 'api.')
  API_LOCATION = '' + '//' + MOD_URI
  WEBSOCKET_LOCATION = location.hostname.replace('app.reba-group.com', 'nervous-engelbart.92-205-164-206.plesk.page')
  // WEBSOCKET_LOCATION = location.hostname.replace('work.', 'api.')
} else {
  API_LOCATION = location.protocol + '//' + location.hostname + ':40030'
  WEBSOCKET_LOCATION = window.location.hostname + ':6001'
}
export const API_URL = API_LOCATION
export const WEBSOCKET_HOST = WEBSOCKET_LOCATION

function getToken ({ commit }, payload) {
  const data = {
    username: payload.email,
    password: payload.password,
    grant_type: 'password',
    client_id: CLIENT_ID,
    client_secret: CLIENT_SECRET,
    scope: '*'
  }
  var url = API_URL + '/oauth/token'

  return axios.post(url, data, {
    transformRequest: [
      function () {
        return transformDataToParams(data)
      }
    ]
  }).then(function (r) {
    console.log(payload.email)
    localStorage.setItem('accessToken' + payload.email, r.data.access_token)
    localStorage.setItem('tokenTimestamp', Math.floor(Date.now() / 1000))

    commit('setLoading', false)

    const newUser = {
      email: payload.email
    }
    commit('setUser', newUser)

    localStorage.setItem('user', JSON.stringify(newUser))

    console.log(r)

    // register echo and socket client
    var echo = new Echo({
      broadcaster: 'socket.io',
      client: require('socket.io-client'),
      host: WEBSOCKET_HOST,
      auth: {
        headers: {
          Authorization: 'Bearer ' + store.getters.getBearerToken
        }
      }
    })

    Vue.use(VueEcho, echo)
  }, function (err) {
    err.message = err.response.data.message

    commit('setLoading', false)
    commit('setError', err)
    console.log(JSON.stringify(err))
  }).catch(e => console.error('#### ' + e))
}

function transformDataToParams (data) {
  const str = []
  for (const p in data) {
    if (data.hasOwnProperty(p) && data[p]) {
      if (typeof data[p] === 'string') {
        str.push(encodeURIComponent(p) + '=' + encodeURIComponent(data[p]))
      }
      if (typeof data[p] === 'object') {
        for (const i in data[p]) {
          str.push(encodeURIComponent(p) + '=' + encodeURIComponent(data[p][i]))
        }
      }
    }
  }
  return str.join('&')
}



// WEBPACK FOOTER //
// ./src/store/index.js